import clsx from 'clsx'
import type { ReactNode } from 'react'
import React from 'react'

import RatingDownIcon from '@/assets/img/ico-rate-down.svg?react'
import RatingUpIcon from '@/assets/img/ico-rate-up.svg?react'
import OrderComplete from '@/assets/img/order-completed.svg?react'
import OrderCreateIcon from '@/assets/img/orders-create-icon.svg?react'
import RevenueIcon from '@/assets/img/revenue-icon.svg?react'
import Satisfaction from '@/assets/img/satisfaction-score-icon.svg?react'
import TrendChart from '@/compoments/charts/TrendChart'
import type { ExecutivesDashboardData } from '@/types/executives'

interface JobStatistics {
    label: string
    icon: ReactNode
    trend: 'up' | 'down'
    value: number
    percent: number
}

const JobStatistics = ({ data }: { data?: ExecutivesDashboardData }) => {
    const jobStatistics: JobStatistics[] = [
        {
            label: 'Revenue Generated',
            icon: <RevenueIcon />,
            trend: Number(data?.totalRevenue?.changed) >= 0 ? 'up' : 'down',
            value: data?.totalRevenue?.value || 0,
            percent: Number(data?.totalRevenue?.changed) || 0,
        },
        {
            label: 'Orders Created',
            icon: <OrderCreateIcon />,
            trend: Number(data?.ordersCreated?.changed) >= 0 ? 'up' : 'down',
            value: data?.ordersCreated?.value || 0,
            percent: Number(data?.ordersCreated?.changed) || 0,
        },
        {
            label: 'Completed',
            icon: <OrderComplete />,
            trend: Number(data?.ordersCompleted?.changed) >= 0 ? 'up' : 'down',
            value: data?.ordersCompleted?.value || 0,
            percent: Number(data?.ordersCompleted?.changed) || 0,
        },
        {
            label: 'Satisfaction Score',
            icon: <Satisfaction />,
            trend:
                Number(data?.satiscfactionScore?.changed) >= 0 ? 'up' : 'down',
            value: Number(data?.satiscfactionScore?.satisfactionScore) || 0,
            percent: Number(data?.satiscfactionScore?.changed) || 0,
        },
    ]
    return (
        <div className="col-12">
            <div className="row gutters-18">
                {jobStatistics.map((item, index) => (
                    <div key={index} className="col-xl-3 col-md-6 col-12">
                        <div className="card card-shadow card-seo">
                            <div className="card-body">
                                <div className="card-seo-info flex-shrink-0">
                                    <div className="seo-title">
                                        <span className="ico">{item.icon}</span>
                                        <span className="name">
                                            {item.label}
                                        </span>
                                    </div>
                                    <h1 className="seo-stat-title">
                                        {item.value}
                                    </h1>
                                </div>
                                <div
                                    className="card-seo-chart"
                                    style={{
                                        height: 60,
                                        width: 100,
                                    }}
                                >
                                    <TrendChart trend={item.trend} />
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="seo-rating-row">
                                    <div
                                        className={clsx(
                                            'seo-rating',
                                            `--${item.trend}`,
                                        )}
                                    >
                                        <span className="ico">
                                            {item.trend === 'up' ? (
                                                <RatingUpIcon />
                                            ) : (
                                                <RatingDownIcon />
                                            )}
                                        </span>{' '}
                                        <span>
                                            {item.trend === 'up' ? '+' : '-'}
                                            {item.percent}%
                                        </span>
                                    </div>
                                    <p className="seo-rating-desk">
                                        <span>vs</span> yesterday
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default JobStatistics
